import GroupsCard from "./GroupsCard"

export default  GroupsCard;



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionsWithGroups/Groups/GroupsCard/index.js